import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@ess-front/shared/tokens';
import { ReactNativeWindow } from '@app/utils/models/react-native-window.model';

@Injectable({
  providedIn: 'root',
})
export class ReactNativeService {
  reactNativeWindow: ReactNativeWindow;
  constructor(@Inject(WINDOW) window: Window) {
    this.reactNativeWindow = window as ReactNativeWindow;
  }

  postMessage(message: string): void {
    if (this.reactNativeWindow.ReactNativeWebView) {
      this.reactNativeWindow.ReactNativeWebView.postMessage(message);
    }
  }
  isApp(): boolean {
    return !!this.reactNativeWindow.ReactNativeWebView;
  }
}
